import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  createdAt: () => faker.date.recent(),
  email: () => faker.internet.email(),
  enabled: true,
  filters() {
    return {
      type: 'unfiltered',
    };
  },
  companyId: null,
  accessToken: 'access',
  refreshToken: 'refresh',
  googleId: '1337',
});
